import React from 'react'
import { Button, ListGroup } from 'react-bootstrap'

import Colors from 'utils/colors'

import '../assets/css/sidebar.css'
import { useNavigate } from 'react-router'

const SideBar = ({page = ""}) => {

  const navigate = useNavigate()
  return (
    <div style={sidebarStyle}>
      <img width={'80%'} src={'/images/cine-yelmo.png'} alt="Yelmo" style={imageContainerStyle} />

      <ListGroup className="flex-column" style={listGroupStyle}>
        <ListGroup.Item action onClick={() => {
          navigate('/home')
        }} className='list-item px-4'>
          <div className='text-white'>Dashboard</div>
        </ListGroup.Item>
        <ListGroup.Item action onClick={() => {
          navigate('/dinamica')
        }} className='list-item px-4'>
          <div className='text-white'>Crear Dinámica</div>
        </ListGroup.Item>
        <ListGroup.Item action onClick={() => {
          navigate('/rewards')
        }} className='list-item px-4'>
          <div className='text-white'>Recompensas</div>
        </ListGroup.Item>
        <ListGroup.Item action onClick={() => {
          // navigate('/rewards')
        }} className='list-item px-4'>
          <div className='text-white'>Datos de uso</div>
        </ListGroup.Item>

      </ListGroup>

      <div style={footerStyle}>
        <Button variant="primary" className='f-14' onClick={() => {
          navigate('/')
        }}>
          Cerrar sesión
        </Button>
      </div>
    </div>
  )
}

export default SideBar

const sidebarStyle = {
  width: '200px',
  minWidth: '200px',
  height: '100vh',
  
  position: 'sticky',
  left: 0,
  top: 0,
  backgroundColor: Colors.secondary,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px 10px',
  boxShadow: '2px 0px 5px rgba(0,0,0,0.1)',
  overflowY: 'auto',
}

const imageContainerStyle = {
  width: '80%',
  marginBottom: '20px',
  objectFit: 'contain',
}

const listGroupStyle = {
  border: 'none',
  flex: 1,
  width: '100%',
}

// const activeStyle = {
//   backgroundColor: '#30475e',
//   fontWeight: 'bold',
// }

const footerStyle = {
  marginBottom: '100px',
}

// const buttonStyle = {
//   background: Colors.primary,
//   borderColor: Colors.primary,
//   borderRadius: '10px',
//   color: Colors.white,
//   fontSize: 'medium',
//   fontWeight: 'bold',
//   height: '50px',
//   width: '170px',
// }
